import { graphql, useStaticQuery } from "gatsby";

export const FormTallerAprendizajeQuery = () => {
    const data = useStaticQuery(graphql`
        query contentfulFormTallerAprendizaje {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "7isYs04j1eZLKsXfZ1bb9H" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            textoTerminosMigrantes {
                                raw
                            }
                            obligatorio
                            seccion
                            placeholder
                            tabOrder
                            ayuda
                        }
                        tituloBoton
                    }
                }
            }
            modalSuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "mQBx9zEPMI6MEFzmAm0Kn" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalSuccessVacantes: allContentfulContactenos(
                filter: { contentful_id: { eq: "4TqOl3pWkrBavajmYXMtth" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalSuccessTallerCursos: allContentfulContactenos(
                filter: { contentful_id: { eq: "7zhy13zXVcB2Te6Ai5rUT9" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                    auxText
                }
            }
            modalSuccessTallerVacantes: allContentfulContactenos(
                filter: { contentful_id: { eq: "4P6L4Zn581IqM2zZVp8lmI" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            pantallaRegistroDuplicado: allContentfulContactenos(
                filter: {contentful_id: {eq: "2pjAkHIOOh9zQbhCsCRJdq"}}
            ) {
                nodes {
                    contentful_id
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                }
            }
            modalWithoutAge: allContentfulContactenos(
                filter: { contentful_id: { eq: "2MCMN2vRDLfvotbMmnLVgy" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcionFormulario{
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
        }
    `);
    return data;
}